/* eslint-disable */
// prettier-ignore
import type { AspidaClient } from 'aspida'
// prettier-ignore
import { dataToURLString } from 'aspida'
// prettier-ignore
import type { Methods as Methods0 } from './api/mail-magazine'
// prettier-ignore
import type { Methods as Methods1 } from './api/sim-inquiry'
// prettier-ignore
import type { Methods as Methods2 } from './api/whitepaper-inquiry'
// prettier-ignore
import type { Methods as Methods3 } from './articles'
// prettier-ignore
import type { Methods as Methods4 } from './articles/_id@string'
// prettier-ignore
import type { Methods as Methods5 } from './banner'
// prettier-ignore
import type { Methods as Methods6 } from './categories'
// prettier-ignore
import type { Methods as Methods7 } from './tags'
// prettier-ignore
import type { Methods as Methods8 } from './whitepapers'
// prettier-ignore
import type { Methods as Methods9 } from './whitepapers/_id@string'

// prettier-ignore
const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '')
  const PATH0 = '/api/mail-magazine'
  const PATH1 = '/api/sim-inquiry'
  const PATH2 = '/api/whitepaper-inquiry'
  const PATH3 = '/articles'
  const PATH4 = '/banner'
  const PATH5 = '/categories'
  const PATH6 = '/tags'
  const PATH7 = '/whitepapers'
  const GET = 'GET'
  const POST = 'POST'

  return {
    api: {
      mail_magazine: {
        post: (option: { body: Methods0['post']['reqBody'], config?: T }) =>
          fetch<Methods0['post']['resBody']>(prefix, PATH0, POST, option).json(),
        $post: (option: { body: Methods0['post']['reqBody'], config?: T }) =>
          fetch<Methods0['post']['resBody']>(prefix, PATH0, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH0}`
      },
      sim_inquiry: {
        post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody']>(prefix, PATH1, POST, option).json(),
        $post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody']>(prefix, PATH1, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH1}`
      },
      whitepaper_inquiry: {
        post: (option: { body: Methods2['post']['reqBody'], config?: T }) =>
          fetch<Methods2['post']['resBody']>(prefix, PATH2, POST, option).json(),
        $post: (option: { body: Methods2['post']['reqBody'], config?: T }) =>
          fetch<Methods2['post']['resBody']>(prefix, PATH2, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH2}`
      }
    },
    articles: {
      _id: (val1: string) => {
        const prefix1 = `${PATH3}/${val1}`

        return {
          get: (option?: { query?: Methods4['get']['query'], config?: T }) =>
            fetch<Methods4['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { query?: Methods4['get']['query'], config?: T }) =>
            fetch<Methods4['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods4['get']['query'] }) =>
            `${prefix}${prefix1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        }
      },
      get: (option?: { query?: Methods3['get']['query'], config?: T }) =>
        fetch<Methods3['get']['resBody']>(prefix, PATH3, GET, option).json(),
      $get: (option?: { query?: Methods3['get']['query'], config?: T }) =>
        fetch<Methods3['get']['resBody']>(prefix, PATH3, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods3['get']['query'] }) =>
        `${prefix}${PATH3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    banner: {
      get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody']>(prefix, PATH4, GET, option).json(),
      $get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody']>(prefix, PATH4, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods5['get']['query'] }) =>
        `${prefix}${PATH4}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    categories: {
      get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
        fetch<Methods6['get']['resBody']>(prefix, PATH5, GET, option).json(),
      $get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
        fetch<Methods6['get']['resBody']>(prefix, PATH5, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods6['get']['query'] }) =>
        `${prefix}${PATH5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    tags: {
      get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
        fetch<Methods7['get']['resBody']>(prefix, PATH6, GET, option).json(),
      $get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
        fetch<Methods7['get']['resBody']>(prefix, PATH6, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods7['get']['query'] }) =>
        `${prefix}${PATH6}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    whitepapers: {
      _id: (val1: string) => {
        const prefix1 = `${PATH7}/${val1}`

        return {
          get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
            fetch<Methods9['get']['resBody']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
            fetch<Methods9['get']['resBody']>(prefix, prefix1, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods9['get']['query'] }) =>
            `${prefix}${prefix1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        }
      },
      get: (option?: { query?: Methods8['get']['query'], config?: T }) =>
        fetch<Methods8['get']['resBody']>(prefix, PATH7, GET, option).json(),
      $get: (option?: { query?: Methods8['get']['query'], config?: T }) =>
        fetch<Methods8['get']['resBody']>(prefix, PATH7, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods8['get']['query'] }) =>
        `${prefix}${PATH7}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    }
  }
}

// prettier-ignore
export type ApiInstance = ReturnType<typeof api>
// prettier-ignore
export default api
